<template>
	<Layout>
		<div class="section">
			<div class="container" style="max-width: 1160px">
				<div class="section--header">
					<h2 class="section--title">{{companyInfo.name}}</h2>
					<p class="section--description">{{companyInfo.introduction}}</p>
				</div>
				
				<div class="about-container">
					<div class="am-g">
						<div class="am-u-md-6">
							<div class="our-company-text">
                <h3 style="font-size: 24px; font-weight: bold; color: #343A40; margin-bottom: 20px;">
                  关于峦璞你需要知道哪些？
                </h3>

                <p style="font-size: 17px; line-height: 1.8; color: #555;">
                  峦璞是一家集前沿科技与绿色实体为一体的
                  <span style="color: #007BFF; background: linear-gradient(to right, #007BFF, #28A745); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-weight: bold;">
    “前行者”
  </span>
                  绿色科技型企业。
                </p>

                <p style="font-size: 17px; line-height: 1.8; color: #555; margin-top: 15px;">
                  通过技术创新与资源循环利用，赋能企业智能化升级，推动绿色经济发展，实现社会、环境与经济的和谐共生。
                </p>

                <p style="font-size: 17px; line-height: 1.8; color: #555; margin-top: 15px;">
                  依托自身信息技术优势，峦璞积极探索科技赋能环保的新模式，开展再生资源回收、加工与再利用业务。我们以
                  <span style="color: #28A745; font-weight: bold;">“绿色循环，共创未来”</span>
                  为理念，通过智能化管理平台与先进技术，推动废旧金属、塑料、纸张、电子废弃物等资源的循环利用，减少环境污染，助力碳中和目标。
                </p>
							</div>
						</div>
						
						<div class="am-u-md-6">
							<div class="our-company-quote">
								<div class="am-g">
									<div class="am-u-md-6">
										<div class="our-company-img">
											<img src='https://luanpu.oss-cn-beijing.aliyuncs.com/jianjie/ls.png' alt="" style="height: 300px" />
										</div>
									</div>
									
									<div class="am-u-md-6">
                    <h3 style="font-size: 24px; font-weight: bold; color: #343A40; margin-bottom: 20px;">
                      峦璞的核心优势
                    </h3>

                    <p style="font-size: 16px; line-height: 1.6; color: #555;">
                      峦璞以<span style="color: #007BFF; font-weight: bold;">科技创新</span>与<span style="color: #28A745; font-weight: bold;">绿色责任</span>为双轮驱动，打造独特竞争力：
                    </p>

                    <ul style="font-size: 16px; line-height: 1.6; color: #555; margin-top: 10px; padding-left: 20px;">
                      <li style="margin-bottom: 8px;">
                        <span style="color: #007BFF; font-weight: bold;">技术领先：</span>专注云计算、大数据、人工智能，提供智能化解决方案。
                      </li>
                      <li style="margin-bottom: 8px;">
                        <span style="color: #28A745; font-weight: bold;">绿色实践：</span>通过智能平台推动资源高效利用，减少环境污染。
                      </li>
                      <li style="margin-bottom: 8px;">
                        <span style="color: #343A40; font-weight: bold;">协同发展：</span>融合信息技术与环保科技，探索新模式。
                      </li>
                    </ul>

                    <p style="font-size: 16px; line-height: 1.6; color: #555; margin-top: 10px;">
                      未来，峦璞将以<span style="color: #007BFF; font-weight: bold;">创新</span>和<span style="color: #28A745; font-weight: bold;">绿色</span>为核心，推动智能化与可持续发展。
                    </p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
export default {
	name: "AboutView",
	components: {Layout},
	data(){
		return{
			companyInfo:{},
			designers:[],
		}
	},
	mounted() {
		this.getCompanyInfo()
		this.getDesigners()
	},
	methods:{
		getCompanyInfo(){
			this.getRequest("/findCompanyInfo").then(resp =>{
				if (resp){
					this.companyInfo = resp.data.data
				}
			})
		},
		getDesigners(){
			this.getRequest("/findDesigners").then(resp =>{
				if (resp){
					this.designers = resp.data.data
				}
			})
		}
		
	}
}
</script>
<style scoped>
/* 移动端适配 */
@media (max-width: 768px) {
  .section--title {
    font-size: 28px !important;
    line-height: 1.3;
  }

  .section--description {
    font-size: 16px !important;
  }

  /* 双栏布局改为垂直堆叠 */
  .am-u-md-6 {
    width: 100% !important;
    padding: 0 15px;
  }

  .our-company-img img {
    height: auto !important;
    max-width: 100%;
    margin: 20px 0;
  }

  /* 文字内容优化 */
  h3 {
    font-size: 22px !important;
    margin-bottom: 15px !important;
  }

  p {
    font-size: 15px !important;
    line-height: 1.7 !important;
  }

  ul {
    padding-left: 18px !important;
  }

  li {
    margin-bottom: 6px !important;
    word-break: break-word;
  }

  /* 增加模块间距 */
  .about-container {
    margin-top: 20px;
  }

  /* 按钮类元素适配 */
  .btn {
    display: block;
    width: 100%;
    padding: 12px;
  }

  /* 图片文字混排优化 */
  .our-company-quote .am-g {
    flex-direction: column;
  }
}

/* 通用优化 */
.our-company-img {
  border-radius: 8px;
  overflow: hidden;
}

.section--header {
  text-align: center;
  padding: 0 15px;
}

/* 提升可读性 */
p {
  text-align: justify;
  hyphens: auto;
}
</style>